<template>
    <v-chip :color="color" text-color="white" small>
        <v-avatar>
            <v-icon>{{icon}}</v-icon>
        </v-avatar>
        {{text}}
    </v-chip>
</template>

<script>
    import Vue from 'vue'

    export default {
        props: {
            status: {
                type: String,
                default: null
            }
        },
        data() {
            return {}
        },
        computed: {
            text() {
                switch (this.status) {
                    case 'created':
                        return 'Создана';
                    case 'inProcessing':
                        return 'В обработке';
                    case 'sent':
                        return 'Отправлена';
                    case 'rejected':
                        return 'Отклонена';
                    case 'done':
                        return 'Выполнена';
                    default:
                        return 'Создана';
                }
            },
            color(){
                switch (this.status) {
                    case 'created':
                        return 'blue darken-2';
                    case 'inProcessing':
                        return 'teal darken-2';
                    case 'sent':
                        return 'deep-purple darken-3';
                    case 'rejected':
                        return 'red darken-2';
                    case 'done':
                        return 'green darken-3';
                    default:
                        return 'blue darken-2';
                }
            },
            icon(){
                switch (this.status) {
                    case 'created':
                        return 'mdi-star-circle';
                    case 'inProcessing':
                        return 'mdi-clock';
                    case 'sent':
                        return 'mdi-arrow-right-bold-circle';
                    case 'rejected':
                        return 'mdi-close-circle';
                    case 'done':
                        return 'mdi-check-circle';
                    default:
                        return 'mdi-star-circle';
                }
            }
        },
        methods: {},

        components: {}

    }
</script>

<style scoped>

</style>
